import React from "react";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import Content from "./components/content";
import Search from "./components/search";
import SearchCustomerSegmentProvider from "./searchContext";
import WithSidebar from "../../../templates/withSidebar";

const DashboardCustomerSegment = ({ future = false }) => {
   const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    future ? PAGES.FUTURE_CUSTOMER : PAGES.CURRENT_CUSTOMER
  );

  return (
   
      <SearchCustomerSegmentProvider>
      {/* <Search roleUser={roleUser} /> */}
      <Content roleUser={roleUser} future={future} />
      </SearchCustomerSegmentProvider>
 
   
  );
};

export default DashboardCustomerSegment;
